<template>
  <v-card class="flex px-6 py-5 justify-center align-center step-card" :class="{ 'step-card-suggested': suggested }"
    elevation="0" @click="$emit('click', $event)">
    <div>
      <v-icon v-if="!completed" size="24" :color="suggested ? 'plusIndigoIndigo' : iconColor">{{ icon }}</v-icon>
      <v-icon v-if="completed" size="24" color="#4CAF50">mdi-check-circle</v-icon>
    </div>
    <div class="flex" style="gap:0.625rem">
      <div class="flex flex-col">
        <div v-if="showSuggestedLabel" class="plusIndigoLighten1--text text-uppercase font-weight-semibold"
          style="font-size:0.625rem">SUGGESTED STEP</div>
        <div class="flex flex-col justify-center" :class="{ 'text-decoration-line-through': completed }">
          <div v-if="title">{{ title }}</div>
          <div v-if="description" class="step-card-description plusGreyDarken2--text">{{ description }}</div>
        </div>
      </div>
      <div v-if="suggested" class="flex justify-end align-center">
        <div class="step-card-chevron plusIndigoLighten1 flex justify-center align-center rounded-circle">
          <v-icon size="16" color="white">mdi-chevron-right</v-icon>
        </div>
      </div>
    </div>
  </v-card>
</template>
<script>
export default {
  props: {
    icon: {
      type: String,
    },
    title: {
      type: String
    },
    description: {
      type: String
    },
    suggested: {
      type: Boolean
    },
    showSuggestedLabel: {
      type: Boolean,
      default: false
    },
    completed: {
      type: Boolean
    },
    iconColor: {
      type: String,
      default: 'plusGreyDarken2'
    }
  },
  data() {
    return {

    }
  }
}
</script>
<style scoped>
.step-card {
  gap: 0.5rem;
  font-size: 0.938rem;
  cursor: pointer;
  border: 1px solid var(--grey-lighten-2, #E0E0E0);

}

.step-card-suggested {
  background-color: #F6F7FF;
  border-left: 3px solid #5c6bc0;
}

.step-card-description {
  font-size: 0.938rem;
  font-weight: 500;
}

.step-card-suggested .step-card-description {
  font-size: 0.875rem;
  font-weight: 400;
}

.step-card-chevron {
  width: 2.25rem;
  height: 2.25rem;
  max-width: 2.25rem;
  max-height: 2.25rem;
  padding: 10px;
}
</style>
